import type { Locale } from "./types";

const en = {
  noRows: "No rows match this report.",
  sourceRows: "Rows read: {n}",
  generated: "Generated {at}",
  exportCsv: "CSV",
  exportXlsx: "Excel",
  search: "Search",
  newRecord: "New record",
  save: "Save",
  saved: "Saved as {number}.",
  cancel: "Cancel",
  open: "Open",
  number: "Number",
  title: "Title",
  updated: "Updated",
  noRecords: "No records yet.",
  loading: "Loading…",
  notFound: "This screen is not available.",
  notFoundBody: "It may not be published yet, or it belongs to another department.",
  links: "Links",
  noLinks: "No links.",
  start: "Start",
  yes: "Yes",
  no: "No",
  fixProblems: "Some fields need attention.",
  previous: "Previous",
  next: "Next",
  records: "Records: {n}",
  cases: "Cases: {n}",
  noCases: "No cases yet.",
  stage: "Stage",
  submitted: "Submitted",
  submittedAs: "Submitted. Your reference is {number}.",
  opened: "Opened {number}.",
  noForm: "This service has no intake form yet.",
  unavailable: "This service is not available.",
  pickRecord: "Choose a record in the list to see it here.",
  pickCase: "Choose a case in the list to see it here.",
  linkedCase: "Linked case",
  openCase: "Open case",
  actions: "Next steps",
  noActions: "No step can be taken now.",
  guardUnmet: "The conditions for this step are not met yet.",
  notPermitted: "Another role takes this step.",
  done: "Done.",
  tasks: "Tasks",
  noTasks: "No tasks.",
  timeline: "Timeline",
  noEvents: "Nothing has happened yet.",
  documents: "Documents",
  noDocuments: "No documents.",
  due: "Due {date}",
  preview: "Preview: data comes from the live system; forms do not submit.",
  back: "Back to the list",
};

type Text = typeof en;

const ar: Text = {
  noRows: "لا توجد صفوف مطابقة لهذا التقرير.",
  sourceRows: "الصفوف المقروءة: {n}",
  generated: "تاريخ الإعداد {at}",
  exportCsv: "CSV",
  exportXlsx: "Excel",
  search: "البحث",
  newRecord: "سجل جديد",
  save: "حفظ",
  saved: "تم الحفظ برقم {number}.",
  cancel: "إلغاء",
  open: "فتح",
  number: "الرقم",
  title: "العنوان",
  updated: "آخر تحديث",
  noRecords: "لا توجد سجلات بعد.",
  loading: "جار التحميل…",
  notFound: "هذه الشاشة غير متاحة.",
  notFoundBody: "ربما لم تنشر بعد، أو تتبع إدارة أخرى.",
  links: "الروابط",
  noLinks: "لا توجد روابط.",
  start: "بدء",
  yes: "نعم",
  no: "لا",
  fixProblems: "بعض الحقول تحتاج إلى مراجعة.",
  previous: "السابق",
  next: "التالي",
  records: "السجلات: {n}",
  cases: "الملفات: {n}",
  noCases: "لا توجد ملفات بعد.",
  stage: "المرحلة",
  submitted: "تاريخ التقديم",
  submittedAs: "تم التقديم. الرقم المرجعي: {number}.",
  opened: "فتح الملف {number}.",
  noForm: "لا يوجد نموذج طلب لهذه الخدمة بعد.",
  unavailable: "هذه الخدمة غير متاحة.",
  pickRecord: "يختار سجل من القائمة لعرضه هنا.",
  pickCase: "يختار ملف من القائمة لعرضه هنا.",
  linkedCase: "الملف المرتبط",
  openCase: "فتح الملف",
  actions: "الخطوات التالية",
  noActions: "لا توجد خطوة متاحة الآن.",
  guardUnmet: "شروط هذه الخطوة غير مستوفاة بعد.",
  notPermitted: "يتولى هذه الخطوة دور آخر.",
  done: "تم.",
  tasks: "المهام",
  noTasks: "لا توجد مهام.",
  timeline: "السجل الزمني",
  noEvents: "لم يحدث شيء بعد.",
  documents: "المستندات",
  noDocuments: "لا توجد مستندات.",
  due: "الموعد {date}",
  preview: "معاينة: البيانات من النظام الفعلي، والنماذج لا ترسل.",
  back: "العودة إلى القائمة",
};

export function screenText(locale: Locale) {
  const dict = locale === "ar" ? ar : en;
  return (key: keyof Text, params: Record<string, string | number> = {}) => dict[key].replace(/\{(\w+)\}/g, (_, k: string) => String(params[k] ?? ""));
}
